import { CSS } from '@dnd-kit/utilities';

export const DndKit = {
  CSS,
};
